import {
  fetchFeedInfo,
  fetchGoodsList,
  fetchCommentList,
  fetchCommentUp,
  fetchCommentReplyList,
  fetchCommentAdd,
  getMtFeedInfo,
  doCommentDel,
} from '@/service/action'
import { fetchSuccess, removeSkeleton,detailRichVideo,detailRichGoods, dealUserData } from '@/utils/mUtil'
import { GoodAdaptor } from '@/service/adaptor'
import { CommentParams } from '@/store/types'

const actions = {
  /**
   * 获取文章详情
   * @param param0
   * @param feedId
   */
  async fetchArticleData({ commit }: any, feedId: number) {
    try {
      return new Promise(async (resolve, reject) => {
        const res = await fetchFeedInfo(feedId)
        fetchSuccess(
          res,
           async(data: any) => {
            if (data && data.content) {
              data.content = data.content.replace(/\n/g, '<br/>')
            }
            if (data.image_info && data.image_info.length) {
              for (let i = 0; i < data.image_info.length; i++){
                let imgArr = data.image_info[i]
                imgArr.bgSizeStr =  'contain'

                if (!imgArr.size) {
                  imgArr.imgOb = new Image();
                  imgArr.imgOb.src = imgArr.image_url
                  imgArr.imgOb.onload = function () {
                    imgArr.size = imgArr.imgOb.width + '*' + imgArr.imgOb.height
                    let curRate = +(imgArr.imgOb.height / imgArr.imgOb.width).toFixed(4)
                    if (curRate > 1.35) {
                      imgArr.bgSizeStr =  'cover'
                    }
                    imgArr.imgOb = null
                    
                  };
                } else {
                  let size = imgArr.size.split('*')
                  if (size.length != 2) continue
                  let curRate = +(+size[1] / +size[0]).toFixed(4)
                  if (curRate > 1.35) {
                    imgArr.bgSizeStr =  'cover'
                  }
                }
              }
             
            }

            //专栏处理 视频与商品dom
            if (data.type === 4) {
              // const { content: contentTemp, richDecodeList } = detailRichVideo(data.rich_content)
              let content = ''
              if (data.rich_base_content) {
                content = window.atob(data.rich_base_content)
                content = decodeURIComponent(content)
                content = await detailRichGoods(content)
              } else if (data.rich_content) {
                content = await detailRichGoods(data.rich_content)
              }
              data.rich_content = content
            }
            data.new_content = dealUserData(data)
            commit('getArticleData', data)
            resolve(res)
          },
          (error: any) => {
            removeSkeleton()
            resolve(res)
            commit('setErrorTxt', error.msg)
          }
        )
      })
    } catch (error) {
      console.log(error)
    }
  },

  getArticleId({ commit }: any, id: string) {
    commit('setId', id)
  },

  /**
   * 获取关联商品
   * @param param0
   * @param feedId
   */
  async _fetchGoodsList({ commit }: any, feedId: number) {
    try {
      const res = await fetchGoodsList(feedId)
      fetchSuccess(
        res,
        (data: any) => {
          commit('setRelativedGoods', GoodAdaptor(data))
        },
        () => {
          commit('setRelativedGoods', [])
        }
      )
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * 获取评论列表
   * @param param0
   * @param param1
   */
  async _fetchCommentList(
    { commit, state }: any,
    params: CommentParams
  ) {
    let res = {}
    try {
      params.pc = params.pc || 10
      res = await fetchCommentList(params)
      fetchSuccess(res, (data: any) => {
        if (params.pn === 1) {
          commit('setCommentData', data)
        } else {
          const { commentData } = state
          commentData.list.push(...data.list)
          commit('setCommentData', commentData)
        }
      })
    } catch (error) {
      console.log(error)
    }
    return res
  },

  /**
   * 评论点赞
   * @param param0
   * @param param1
   */
  async _fetchCommentUp(
    { commit }: any,
    { feedId, comment_id, content, cuuid, isReply, parentCommentId }: { feedId: number; comment_id: number; content: string; cuuid: string, isReply?: boolean, parentCommentId?: string }
  ) {
    try {
      const res = await fetchCommentUp(feedId, comment_id, content, cuuid)
      fetchSuccess(res, (data: any) => {
        commit('updatePraiseNum', { comment_id, num: data.up_count, isReply, parentCommentId })
      })
    } catch (error) {
      console.log(error)
    }
  },

  async _fetchCommentReplyList(
    { commit, state }: any,
    { feed_id, comment_id, pc, pn }: any
  ) {
    let res = null
    try {
      res = await fetchCommentReplyList({ feed_id, comment_id, pc, pn })
      fetchSuccess(res, (data: any) => {
        if (data.list && data.list.length) {
          const { commentData } = state
          const comment = commentData.list.find(
            (v: any) => v.comment_id === comment_id
          )
          // const comment = commentData.list[0];
          let replyList = commentData.list.find(
            (v: any) => v.comment_id === comment_id
          ).reply_list
          // const replyList = comment.reply_list;
          if (pn == 1) {
            const addedList = comment.reply_list.filter((comment: any) => comment.is_add == 1)
            comment.reply_list = [...addedList, ...data.list]
          } else {
            replyList.push(...data.list)
          }
          commit('setCommentData', commentData)
        }
      })
    } catch (error) {
      console.log(error)
    }
    return res
  },

  /**
   * 发布评论
   * @param param0
   * @param param1
   */
  async _fetchCommentAdd(
    { commit, state }: any,
    { feed_id, parent_id, content, successCb, type, rootId, context, at_user_info }: any
  ) {
    try {
      const { commentData } = state
      const list = commentData.list
      const UserInfo = (window as any).userInfo

      let avatar_m = ''
      if (typeof UserInfo.avatar == 'string') {
        avatar_m = JSON.parse(UserInfo.avatar).m
      } else {
        avatar_m = UserInfo.avatar.m
      }
      let comment_be_reply_info = {}
      if (type == 2) {
        const replyRootComment = list.find((v: any) => v.comment_id === rootId)
        comment_be_reply_info = {
          comment_id: String(replyRootComment?.comment_id),
          uuid: replyRootComment?.user?.uuid,
          nickname: replyRootComment?.user?.nickname
        }
      }
      const res = await fetchCommentAdd({ feed_id, parent_id, content, at_user_info, comment_be_reply_info: JSON.stringify(comment_be_reply_info) })
      fetchSuccess(
        res,
        (data: any) => {
          successCb && successCb()
          if (type === 1) {
            // 模拟评论数据
            list.unshift({
              comment_id: data.comment_id,
              content,
              praise_num: '',
              date: '刚刚',
              reply_list: [],
              user: {
                nickname: UserInfo.nickname,
                uuid: UserInfo.uuid,
                photo: avatar_m,
              },
              at_user_infos: !!at_user_info ? JSON.parse(at_user_info) : []
            })

            if (!isNaN(commentData.total)) {
              commentData.total = +commentData.total + 1
            }
            const articleData = state.data
            if (!isNaN(articleData.comment_num)) {
              articleData.comment_num = +articleData.comment_num + 1
              commit('getArticleData', articleData)
            }
          } else if (type === 2) {
            const replyRootComment = list.find((v: any) => v.comment_id === rootId)
            replyRootComment.reply_comment_num += 1
            // 模拟回复数据
            const replyList = replyRootComment?.reply_list

            const replyComment = replyList.find(
              (v: any) => v.comment_id === parent_id
            )
            replyList.unshift({
              comment_id: data.comment_id,
              content,
              praise_num: '',
              date: '刚刚',
              user: {
                nickname: UserInfo.nickname,
                uuid: UserInfo.uuid,
                photo: avatar_m,
              },
              is_add: 1,
              to_user: rootId == parent_id ? replyRootComment ? replyRootComment.user : {} : replyComment ? replyComment.user : {},
              at_user_infos: !!at_user_info ? JSON.parse(at_user_info) : []
            })
          }
          commit('setCommentData', commentData)
        },
        (error: any) => {
          context.$toast(error.msg)
        }
      )
    } catch (error) {
      console.log(error)
    }
  },


  /**
   * 删除评论
   * @param param0
   * @param param1
   */
   async _fetchCommentDel(
    { commit, state }: any,
    { feed_id, comment_id, successCb, type, root_id, context }: any
  ) {
    try {
      const res = await doCommentDel({ feed_id, comment_id })
      fetchSuccess(
        res,
        (data: any) => {
          successCb && successCb()
          const { commentData } = state
          const list = commentData.list
          if (type === 1) {
            // 模拟删除评论数据
            let index = list.findIndex((item: any) =>item.comment_id === comment_id)
            list.splice(index,1)
            if (!isNaN(commentData.total)) {
              commentData.total = +commentData.total - 1
            }
            const articleData = state.data
            if (!isNaN(articleData.comment_num)) {
              articleData.comment_num = +articleData.comment_num - 1
              commit('getArticleData', articleData)
            }
          } else if (type === 2) {
            // 模拟删除回复数据
            const replyItem = list.find((v: any) => v.comment_id === root_id);
          
            replyItem.comment_num = +replyItem.comment_num - 1;
            replyItem.reply_comment_num = +replyItem.reply_comment_num - 1;

            const index = replyItem.reply_list.findIndex((v: any) => v.comment_id === comment_id)

            replyItem.reply_list.splice(index,1)

          }
          commit('setCommentData', commentData)
        },
        (error: any) => {
          context.$toast(error.msg)
        }
      )
    } catch (error) {
      console.log(error)
    }
  },


  /**
   * 获取mt数据
   * @param param0
   * @param feedId
   */
  async _fetchMtInfo({ commit }: any, { feedId, localLat, localLng }: any) {
    try {
      let isCompute = 0
      if (localLat != 0) {
        isCompute = 1
      }

      const res = await getMtFeedInfo(feedId, localLat, localLng, isCompute)
      fetchSuccess(res, (data: any) => {
        if (data.mt_type == 1 || data.mt_type == 3) {
          let mtStore = data.mt_store
          if (mtStore) {
            let score = mtStore.score
            let scoreArr = (score + '').split('.')
            if (score % 1 < 0.25) {
              mtStore.scoreVal = scoreArr[0]
            } else if (score % 1 < 0.75) {
              mtStore.scoreVal = +(scoreArr[0] + '.5')
            } else {
              mtStore.scoreVal = +scoreArr[0] + 1
            }
          }
        }
        commit('setMtData', data)
      })
    } catch (error) {
      console.log(error)
    }
  },
}

export default actions
